import { useModalStore } from "@/stores/modalStore";

export function useOpenRemakesFeed() {
  const modalStore = useModalStore();

  async function openRemakesFeed(post, isRemakeFeed = false) {
    if (isRemakeFeed) return;

    const RemakeFeed = (await import("@/components/Feed/RemakeFeed.vue"))
      .default;

    modalStore.openModal({
      component: RemakeFeed,
      props: { post: post },
      options: { lockScroll: true },
    });
  }

  return { openRemakesFeed };
}
